import prependChildAtIndex from '../../../general/prepend/prependChildAtIndex';

import exLanguage from '../../../language';
import * as exElement from '../../../utils/element';

import type { Context } from '../types';

// ----------------------------------------------------------------------------

function progress(ctx: Context): any {
    ctx.shared.elements.progress = {};

    function init(): void {
        // If not using ajax
        if (!ctx.shared.config.ajax) {
            return;
        }

        //
        create();
    }

    function create(): void {
        // Create element (select progress)
        const elSelectProgress = exElement.create({
            merge: ctx.shared.config.progress,
            class: {
                new: 'select-progress',
            },
        });
        prependChildAtIndex(ctx.shared.elements.dropdown.element, elSelectProgress, 1);
        ctx.shared.elements.progress.element = elSelectProgress;

        // --------------------------------------------------------------------

        // Create element (progress result)
        const elProgressResult = exElement.create({
            class: {
                new: 'progress-result',
            },
            style: {
                display: 'none',
            },
            html: ctx.shared.config.fnResult ?? exLanguage.line('general.loading') + '...',
        });
        elSelectProgress.appendChild(elProgressResult);
        ctx.shared.elements.progress.result = elProgressResult;
    }

    // ------------------------------------------------------------------------

    function start(): void {
        exElement.show(getResultElement());
    }

    function stop(): void {
        exElement.hide(getResultElement());
    }

    // ------------------------------------------------------------------------

    function getElement(): HTMLElement {
        return ctx.shared.elements.progress.element;
    }

    function getResultElement(): HTMLElement {
        return ctx.shared.elements.progress.result;
    }

    // ------------------------------------------------------------------------

    return {
        init,
        start,
        stop,
        getElement,
        getResultElement,
    };
}

// ----------------------------------------------------------------------------

export default progress;
